const config = {
  development: {
    pubnubPublishKey: 'pub-c-b8b14417-cff1-4e64-aa43-b41a777352cf',
    pubnubSubscribeKey: 'sub-c-42db9ed2-315c-11e6-9327-02ee2ddab7fe',
    // apiBaseUrl: 'https://api.getvisitapp.net/shanti',
    // apiBaseUrl: 'https://insurance-uat.getvisitapp.net/luffy',
    apiBaseUrl: 'http://localhost:5001',
    //apiBaseUrl: 'https://api.samuraijack.xyz/v3',
   backendTsApiBaseUrl:'http://localhost:7001',
    opentokApiKey: '45467122',
    pharmaServer: 'https://api.getvisitapp.net/absol',
    //pharmaServer: 'http://localhost:2020',
    starSponsorId: 568,
    ILSponsorId: 6620,
    hclSponsorID: 8496,
    mchiSsoSponsorId: 17818,
    oracleSponsorId: 196,
    covidSymptomId: 4811,
    psychologistVerticalId: 1,
    version: '125',
    googleMapsApiKey: 'AIzaSyAPTgIhD7l2ZtMj-3JVAALzp5FHKw0hlB8',
    dashboardVersion: 50,
    nivaSponsorIds: [6624],
  },
  // staging: {
  //   pubnubPublishKey: 'pub-c-b8b14417-cff1-4e64-aa43-b41a777352cf',
  //   pubnubSubscribeKey: 'sub-c-42db9ed2-315c-11e6-9327-02ee2ddab7fe',
  //   apiBaseUrl: 'https://api.getvisitapp.xyz/v3',
  //   opentokApiKey: '45467122',
  // },
  staging: {
    pubnubPublishKey: 'pub-c-b8b14417-cff1-4e64-aa43-b41a777352cf',
    pubnubSubscribeKey: 'sub-c-42db9ed2-315c-11e6-9327-02ee2ddab7fe',
    apiBaseUrl: 'https://api.samuraijack.xyz/telehealth',
    opentokApiKey: '45467122',
    backendTsApiBaseUrl:'https://api.samuraijack.xyz/backend-ts',
    pharmaServer: 'https://api.getvisitapp.net/agni',
    starSponsorId: 196,
    hclSponsorID: 8496,
    ILSponsorId: 6620,
    mchiSsoSponsorId: 17818,
    oracleSponsorId: 196,
    psychologistVerticalId: 1,
    version: '125',
    googleMapsApiKey: 'AIzaSyAPTgIhD7l2ZtMj-3JVAALzp5FHKw0hlB8',
    dashboardVersion: 50,
    nivaSponsorIds: [6624],
  },
  'local-production': {
    pubnubPublishKey: 'pub-c-fb8ac7e3-75bf-4396-bf14-77215f8b9419',
    pubnubSubscribeKey: 'sub-c-78deef00-680f-11e5-a57f-0619f8945a4f',
    apiBaseUrl: '/v3',
    pharmaServer: '/pharmacy',
    backendTsApiBaseUrl: '/v5',
    opentokApiKey: '45440642',
    starSponsorId: 568,
    ILSponsorId: 7823,
    hclSponsorID: 17688,
    mchiSsoSponsorId: 18388,
    oracleSponsorId: 731,
    covidSymptomId: 3642,
    psychologistVerticalId: 1,
    version: '125',
    googleMapsApiKey: 'AIzaSyCOh6iK7nfOvJrfpG3RJsNzyJoJtSl3OXc',
    nivaSponsorIds: [],
    dashboardVersion: 50,
  },
  production: {
    pubnubPublishKey: 'pub-c-fb8ac7e3-75bf-4396-bf14-77215f8b9419',
    pubnubSubscribeKey: 'sub-c-78deef00-680f-11e5-a57f-0619f8945a4f',
    apiBaseUrl: 'https://api.getvisitapp.com/v3',
    opentokApiKey: '45440642',
    pharmaServer: 'https://api.getvisitapp.com/pharmacy',
    backendTsApiBaseUrl:'https://api.getvisitapp.com/v5',
    starSponsorId: 568,
    ILSponsorId: 7823,
    hclSponsorID: 17688,
    mchiSsoSponsorId: 18388,
    oracleSponsorId: 731,
    covidSymptomId: 3642,
    psychologistVerticalId: 1,
    version: '125',
    googleMapsApiKey: 'AIzaSyCOh6iK7nfOvJrfpG3RJsNzyJoJtSl3OXc',
    nivaSponsorIds: [],
    dashboardVersion: 50,
  },
  uat: {
    pubnubPublishKey: 'pub-c-7cd08b37-d86e-44ea-9aaa-52e43d06ae6c',
    pubnubSubscribeKey: 'sub-c-02c13384-7a21-4557-a303-1ae8a18e14c4',
    apiBaseUrl: 'https://uat-api.getvisitapp.net/backend',
    opentokApiKey: '45467122',
    pharmaServer: 'https://uat-api.getvisitapp.net/pharmacy',
    backendTsApiBaseUrl:'https://uat-api.getvisitapp.net/backend-ts',
    starSponsorId: 568,
    hclSponsorID: 17688,
    ILSponsorId: 7823,
    mchiSsoSponsorId: 18388,
    oracleSponsorId: 731,
    psychologistVerticalId: 1,
    version: '125',
    googleMapsApiKey: 'AIzaSyAPTgIhD7l2ZtMj-3JVAALzp5FHKw0hlB8',
    dashboardVersion: 50,
    nivaSponsorIds: [7153],
  },
};

export default config[process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV];
